<div class="modal fade in">
    <div class="backdrop"></div>
    <div
        class="modal-dialog"
        [class]="modalSize">
        <div class="modal-content nlr-busy-modal">
            <div class="modal-header">
                <button
                    type="button"
                    (click)="closeDialog()"
                    title="Close"
                    class="close">
                    <i class="nlrp-icon nlrp-icon-close"></i>
                </button>
                <h4 class="modal-title">{{title}}</h4>
            </div>
            <div class="modal-body">
                <nlr-pdf-print-settings
                    [spatialReference]="settings.spatialReference"
                    [accessRestriction]="settings.accessRestriction"
                    (closeEvent)="closeDialog()"
                    (dismissEvent)="closeDialog()"></nlr-pdf-print-settings>
            </div>
        </div>
    </div>
</div>
